import { render, staticRenderFns } from "./PhoenixBote.vue?vue&type=template&id=6731fecd&scoped=true"
import script from "./PhoenixBote.vue?vue&type=script&lang=js"
export * from "./PhoenixBote.vue?vue&type=script&lang=js"
import style0 from "./PhoenixBote.vue?vue&type=style&index=0&id=6731fecd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6731fecd",
  null
  
)

export default component.exports